// import emailjs from 'emailjs-com';
import { Container } from 'react-bootstrap';
import { Swiper, SwiperSlide } from 'swiper/react';
import { Navigation, Pagination, Autoplay } from 'swiper/modules';
import 'swiper/css';
import 'swiper/css/navigation';
import 'swiper/css/pagination';
import './Home.css';
import NewBanner from "../Components/NewBanner"
import ClientReview from './ClientReview'
import Work from './OurWork'
import FAQ from './FAQ';
import faqImage from '../assets/home/FAQ (2).png';
import LetsTalk from "../Components/LetsTalk"

import Stats from '../Components/Stats';
import WhyChoose from '../Components/WhyChoose';
import { Helmet } from "react-helmet-async";

// Home services image
const images = [
  require('../assets/home/h21-1.png'),
  require('../assets/home/h21-2.png'),
    require('../assets/home/h21-3.png'),
      require('../assets/home/h21-4.png'),
        require('../assets/home/h21-5.png'),
];

// const awardsList = [
//   { img: require("../assets/award_21.png"), imgTitle: "5x Developer Award" },
//   { img: require("../assets/award_21.png"), imgTitle: "Best UI/UX 2023" },
//   { img: require("../assets/award_21.png"), imgTitle: "Innovation Champion" },
//   { img: require("../assets/award_21.png"), imgTitle: "Innovation Champion" },
//   { img: require("../assets/award_21.png"), imgTitle: "Innovation Champion" },
// ]
const faqData = [
  {
    question: "Custom-built websites that drive results",
    answer: " High-performance, scalable websites crafted with clean code, intuitive UX, and your  business goals in mind."
  },
  {
    question: "Marketing strategies that make an impact",
    answer: " From Social Media to SEO, PPC, and Meta Ads, creative meets conversion in every campaign we run."
  },
  {
    question: "Design that defines your identity",
    answer: "  Powerful visual branding, from logos to complete brand systems, that connects with your audience at every touchpoint."
  },
  {
    question: "Visual storytelling that connect and convert",
    answer: "From compelling brand videos to professional product shoots, we capture your story with style, clarity, and impact"
  },

];
const Home = () => {
    return (
    <>
    <Helmet>
  <title>Best Digital Marketing Agency in Bareilly, Uttar Pradesh | 21 Maneuvers</title>

  <meta 
    name="description" 
    content="21 Maneuvers is the best digital marketing agency in Bareilly offering SEO, website development, branding, PPC, and social media marketing services to grow your business."
  />

  <meta 
    name="keywords" 
    content="best digital marketing agency in Bareilly, SEO services Bareilly, website development company Bareilly, branding agency Bareilly, PPC services Bareilly"
  />

  <link rel="canonical" href="https://21maneuvers.in/" />

  {/* Open Graph */}
  <meta property="og:title" content="Best Digital Marketing Agency in Bareilly | 21 Maneuvers" />
  <meta property="og:description" content="Grow your business with expert SEO, website development & digital marketing services in Bareilly." />
  <meta property="og:url" content="https://21maneuvers.in/" />
  <meta property="og:type" content="website" />
  <script type="application/ld+json">
{`
{
  "@context": "https://schema.org",
  "@type": "DigitalMarketingAgency",
  "name": "21 Maneuvers",
  "url": "https://21maneuvers.in",
  "logo": "https://21maneuvers.in/logo.png",
  "address": {
    "@type": "PostalAddress",
    "streetAddress": "Rampur Bagh",
    "addressLocality": "Bareilly",
    "addressRegion": "Uttar Pradesh",
    "addressCountry": "India"
  },
  "telephone": "+91 9311849502"
}
`}
</script>
</Helmet>


    <NewBanner />

    <h1 style={{
  position: "absolute",
  left: "-9999px",
  height: "1px",
  overflow: "hidden"
}}>
  Best Digital Marketing Agency in Bareilly, Uttar Pradesh
</h1>

<WhyChoose/>
    {/* Home-service-section */}
    <Container fluid className="service-container-fluid">
  <Container className="service-content-container">

    {/* LEFT : IMAGE SLIDER */}
    <div className="service-left-section">
      <Swiper
        modules={[Navigation, Pagination, Autoplay]}
        navigation={{
          nextEl: ".custom-swiper-button-next",
          prevEl: ".custom-swiper-button-prev",
        }}
        pagination={{ clickable: true }}
        loop
        autoplay={{
          delay: 3000,
          disableOnInteraction: false,
        }}
        className="service-image-swiper"
      >
        {images.map((img, index) => (
          <SwiperSlide key={index}>
            <img
              src={img}
              alt={`Digital service showcase ${index + 1}`}
              className="service-swiper-image"
              loading="lazy"
            />
          </SwiperSlide>
        ))}

        {/* Custom Navigation Buttons */}
        <div className="custom-swiper-button-prev">←</div>
        <div className="custom-swiper-button-next">→</div>
      </Swiper>
    </div>

    {/* RIGHT : CONTENT */}
    <div className="service-right-section">
 <div className="service-heading-box">
        <p className="page_text">OUR SERVICES</p>

        <p className="page_main_heading ">
          Complete Digital <br />
          Growth Solutions & <br />
          Creative Brand Experiences
        </p>
      </div>

      {/* Services List */}
      <div className="service-services-box page_text fw-bold">

        <div className="page_text ">
          <div className="underline"></div>
          <p className='service-points'>Digital Growth Marketing</p>
          <p className='service-points'>Visual Branding & Design</p>
          <p className='service-points'>Professional Shoots & Media</p>
        </div>

        <div className="page_text ">
          <div className="underline"></div>
          <p className='service-points'>Print & Digital Collateral</p>
          <p className='service-points'>Website Development</p>
          <p className='service-points'>Social Media & Content Strategy</p>
        </div>

      </div>
    </div>

  </Container>
</Container>

    
        <FAQ
          faqs={faqData}
          heading="We Design, Build & Market with Purpose"
          image={faqImage}
          imagePosition="right"
        />
  
      <Work />
       <Stats/>
      
      <ClientReview />
      <LetsTalk/>
     
</>
  )
}

export default Home